import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d4e46f44&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d4e46f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e46f44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4e46f44')) {
      api.createRecord('d4e46f44', component.options)
    } else {
      api.reload('d4e46f44', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d4e46f44&scoped=true&", function () {
      api.rerender('d4e46f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cwVivvyylk2t/JS/comp/DocBox.vue"
export default component.exports